import styles from "./SectionContainer.module.css"
const SectionContainer = ({ children }) => {
    return (
        <div className={styles.sectionContainer}>
            {children}
        </div>
    )
}

export default SectionContainer;